<!--
 * @Description: 公司管理员权限下的公司信息页面
 * @Author: 
 * @Date: 2022-08-03 18:10:34
 * @LastEditTime: 2022-09-01 11:48:24
 * @LastEditors: dongqianqian
 * @Usage: 
-->

<template>
  <div>
    <el-button
      type="primary"
      style="margin-left: 20px"
      v-show="isDisabled"
      @click='isDisabled=false'
    >编辑</el-button>
    <el-button
      type="primary"
      style="margin-left: 20px"
      v-show="!isDisabled"
      @click='save'
    >确定</el-button>
    <el-button
      style="margin-left: 20px"
      v-show="!isDisabled"
      @click="closeClick"
    >取消</el-button>
    <div class="left">
      <el-row>
        <el-col :span="9">
          <el-form
            ref="form"
            :model="form"
            label-width="160px"
          >
            <el-form-item
              label="公司名称:"
              prop="companyName"
            >
              <el-input
                v-model="form.companyName"
                :disabled='isDisabled'
              ></el-input>
            </el-form-item>

            <el-form-item
              label="统一社会信用代码:"
              prop="unitCode"
            >
              <el-input
                v-model="form.unitCode"
                :disabled='isDisabled'
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="账号:"
              prop="userAccount"
            >
              <el-input
                v-model="form.userAccount"
                :disabled='isDisabled'
              ></el-input>
            </el-form-item>

            <el-form-item
              label="密码:"
              prop="userPwd"
            >
              <el-input
                v-model="form.userPwd"
                :disabled='isDisabled'
              ></el-input>
            </el-form-item> -->
            <el-form-item label="公司地点:">
              <el-cascader
                size="large"
                :options="regionOptions"
                style="width:100%;"
                :disabled='isDisabled'
                @change="placeChange"
                v-model="form.selectedOptions"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址:">
              <el-input
                v-model="form.address"
                @input="hanlderInput"
                :disabled='isDisabled'
              ></el-input>
            </el-form-item>

            <el-form-item
              label="平台logo:"
              prop="platFormLogo"
            >
              <el-input
                v-model="form.platFormLogo"
                disabled
                style="width: 80%;"
              ></el-input>

              <el-upload
                :disabled="isDisabled"
                style="display:inline-block;"
                action=""
                :auto-upload="true"
                :http-request="uploadLogo"
                :show-file-list='false'
                :before-upload="beforeAvatarUpload"
              >
                <el-button
                  :disabled="isDisabled"
                  type="primary"
                  style="margin-left: 20px"
                >选择</el-button>
              </el-upload>

            </el-form-item>
            <el-form-item
              label="平台名称:"
              prop="platFormName"
            >
              <el-input
                v-model="form.platFormName"
                :disabled='isDisabled'
              ></el-input>
            </el-form-item>
            <el-form-item label="项目数量:">
              <el-input
                v-model="projectCount"
                disabled
              ></el-input>

            </el-form-item>
            <el-form-item
              label="法人代表:"
              prop="companyLeader"
            >
              <el-input
                v-model="form.companyLeader"
                :disabled='isDisabled'
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="宣传视频:"
              prop="platFormVideo"
            >
              <el-input
                v-model="form.platFormVideo"
                style="width: 80%;"
                disabled
              ></el-input>
              <el-upload
                :disabled="isDisabled"
                style="display:inline-block;"
                action=""
                :auto-upload="true"
                :http-request="uploadVideo"
                :show-file-list='false'
              >
                <el-button
                  type="primary"
                  style="margin-left: 20px"
                  :disabled="isDisabled"
                >选择</el-button>
              </el-upload>
            </el-form-item> -->
          </el-form>
        </el-col>
        <el-col :span="15">
          <Bamap
            class="bai-map"
            :selectAddress="selectAddress"
            :companyInfo="companyInfo"
          ></Bamap>
          <!-- <div
            ref="mapEcharts"
            class="map-ecahrts"
          ></div> -->
        </el-col>
      </el-row>
    </div>
    <!-- <div class="right"></div> -->
  </div>
</template>

<script>
import { chinaName } from '../../assets/worldToChina'
import Bamap from "@/components/bamap.vue";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
import _ from 'lodash'
// import echarts from 'echarts'
import {
  Api_Company,
  Api_Base
} from "@/api/api";
import { getStore } from '@/util/store'

export default {
  data() {
    return {
      isDisabled: true,
      form: {
        selectedOptions: [],
        provinceId: '', //省份
        cityId: '', //城市
        areaId: '', //地区
        address: "", //详细地址
      },
      chinaName: chinaName,
      projectCount: '',// 页面上显示的项目数量
      regionOptions: regionData,
      selectAddress: '',
      companyInfo: this.$store.state.companyInfo,
      // videoList: [],
    };
  },
  components: {
    Bamap
  },
  created() {
    this.getInfo(this.$store.state.companyInfo);
    const unwatch = this.$watch("$store.state.companyInfo", (now) => {
      this.getInfo(now);
      unwatch();
    });
  },
  mounted() {
    // setTimeout(() => {
    //   this.initMap()
    // })
  },
  methods: {
    placeChange(val) {
      // this.form.provinceId = CodeToText[val[0]]
      // this.form.provinceId = CodeToText[val[1]]
      // this.form.provinceId = CodeToText[val[2]]
      if (!val) return
      this.form.provinceId = val[0] ? val[0] * 1 : 0 //省份
      this.form.cityId = val[1] ? val[1] * 1 : 0 //城市
      this.form.areaId = val[2] ? val[2] * 1 : 0 //地区
      this.getSelectTree(val)
    },
    hanlderInput: _.debounce(function () {
      this.getSelectTree(this.form.selectedOptions)
    }, 3000),
    getSelectTree(val) {
      if (!val.length) return
      // TODO 树状结构遍历待优化
      let province = ''
      let city = ''
      let area = ''
      this.regionOptions.map(p => {
        if (p.value === val[0]) {
          province = p.label
          p.children.map(c => {
            if (c.value === val[1]) {
              city = c.label
              c.children.map(a => {
                if (a.value === val[2]) {
                  area = a.label
                }
              })
            }
          })
        }
      })
      this.selectAddress = `${province}${city}${area}${this.form.address}`
      console.log('this.selectAddress=', this.selectAddress)
      return this.selectAddress
    },
    closeClick() {
      this.isDisabled = true;
    },
    beforeAvatarUpload(file) {
      const typeArr = ["image/png", "image/gif", "image/jpeg", "image/jpg"];
      const isJPG = typeArr.indexOf(file.type) !== -1;
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("只能上传图片!");
      }
      if (!isLt3M) {
        this.$message.error("上传头像图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    uploadLogo(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(1, formData).then(res => {
        this.form.platFormLogo = res.data.data[0].fileUrl
        this.$message({
          type: "success",
          message: "上传成功!",
        });
      })
    },
    uploadVideo(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(3, formData).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          if (result.data && result.data.length) {
            this.form.platFormVideo = result.data[0].fileUrl
            this.$message({
              type: "success",
              message: "上传成功!",
            });
          }
        }
      })
    },
    save() {
      this.form.id = getStore({ name: 'companyId' })
      Api_Company.edit(this.form).then(res => {
        this.isDisabled = true
        this.$store.dispatch('getCompanyInfo')
        this.$store.dispatch('getUserInfo')
      })
    },
    getInfo(now) {
      this.form = _.cloneDeep(now)
      this.form.selectedOptions = [
        now.provinceId + "",
        now.cityId + "",
        now.areaId + "",
      ];
      this.form.projectCount = now.projectCount
      this.projectCount = now.usedProjectCount + '/' + now.projectCount
      this.getSelectTree(this.form.selectedOptions)
    },
  },
};
</script>

<style>
.map-ecahrts {
  height: 540px;
  width: 500px;
}
.bai-map {
  margin-left: 100px;
}
</style>